
import bannerPt from "@/assets/feature-project-banner/banner-dioroom-pt.png";
import bannerEn from "@/assets/feature-project-banner/banner-dioroom-en.png";

export const projectLink = "https://play.google.com/store/apps/details?id=com.BlackPaladins.Dioroom"; 
export const featuredProject = {
    pt:{
        banner: bannerPt
    },
    en: {
        banner: bannerEn
    }
} 